const config = {
	signIn: {
		domain: 'statvis-ax-user-pool-domain.auth.eu-west-1.amazoncognito.com',
		clientId: '6ovd3bafe7b5mpf25itmlhk84a',
		redirectURI: 'https://statvis.test.qax.io/',
	},
	userPool: 'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_uChX7hKfR',
	identityPoolId: 'eu-west-1:1388de05-9e70-45e1-9aa1-c5dab8b34cb3',
	primaryAccountName: 'test',
	secondaryAccounts: [
		{
			accountId: '640193690919',
			accountName: 'test2',
			rolePath: 'cdk/eu-west-1/statvis-client-test2-eu-west-1/',
			roleName: 'statvis-client-test2-eu-w-StatvisAssumeableRole97D-15COH5T8Q0Z02',
		},
	],
}

export default config
